import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './about-us.css'

const AboutUs = (props) => {
  return (
    <div className="about-us-container1">
      <Helmet>
        <title>About Us - Panda Demolition &amp; Disposal</title>
        <meta
          property="og:title"
          content="About Us - Panda Demolition & Disposal"
        />
        <link
          rel="canonical"
          href="https://www.pandademolition.com/about-us"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="about-us-hero-section">
        <div className="about-us-hero-video-wrapper">
          <video
            src="https://videos.pexels.com/video-files/19672091/19672091-hd_1920_1080_24fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/19672091/pictures/preview-0.jpeg"
            autoPlay="true"
            playsInline="true"
            className="hero-video"
          ></video>
          <div className="about-us-hero-overlay"></div>
        </div>
        <div className="about-us-hero-content-container">
          <div className="about-us-hero-text-block">
            <span className="section-subtitle">
              Panda Demolition &amp; Disposal
            </span>
            <h1 className="hero-title">
              <span>
                Precision Demolition.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
            </h1>
            <p className="hero-description section-content">
              {' '}
              With over 15 years of industry leadership, we set the standard for
              safety-first demolition and high-capacity disposal services. From
              residential teardowns to complex industrial site clearing, our
              mission is to deliver clean slates with zero compromise on safety.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </p>
            <div className="about-us-hero-cta-group">
              <a href="/rfq-portal">
                <div className="btn btn-xl btn-secondary">
                  <span>Request Project RFQ</span>
                </div>
              </a>
              <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="navigation-btn-reset">
                <div className="btn-outline btn btn-xl">
                  <span>Book a Dumpster</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="timeline-section">
        <div className="timeline-container">
          <div className="timeline-header">
            <h2 className="section-title">Our Legacy of Excellence</h2>
            <p className="section-content">
              Scaling operations and setting safety milestones since day one.
            </p>
          </div>
          <div className="timeline-track">
            <div className="left timeline-item">
              <div className="timeline-content">
                <span className="timeline-year">2008</span>
                <h3 className="timeline-event-title">Founded in Detroit</h3>
                <p className="section-content">
                  Panda Demolition began with a single truck and a commitment to
                  cleaning up the city&apos;s industrial footprint.
                </p>
              </div>
            </div>
            <div className="right timeline-item">
              <div className="timeline-content">
                <span className="timeline-year">2012</span>
                <h3 className="timeline-event-title">
                  OSHA Diamond Certification
                </h3>
                <p className="section-content">
                  Achieved the highest safety rating in the region, establishing
                  our &quot;Safety-First&quot; operational protocol.
                </p>
              </div>
            </div>
            <div className="left timeline-item">
              <div className="timeline-content">
                <span className="timeline-year">2016</span>
                <h3 className="timeline-event-title">Fleet Expansion</h3>
                <p className="section-content">
                  Doubled our capacity with 50+ new heavy-duty roll-off trucks
                  and high-reach excavators.
                </p>
              </div>
            </div>
            <div className="right timeline-item">
              <div className="timeline-content">
                <span className="timeline-year">2023</span>
                <h3 className="timeline-event-title">
                  Sustainability Milestone
                </h3>
                <p className="section-content">
                  Processed over 1 million tons of debris with a 75% recycling
                  diversion rate across all projects.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="safety-section">
        <div className="safety-container">
          <div className="safety-intro">
            <h2 className="section-title">Uncompromising Safety Standards</h2>
            <p className="section-content">
              Safety isn&apos;t just a checkbox; it&apos;s our core DNA. We
              adhere to the strictest federal and state regulations.
            </p>
          </div>
          <div className="safety-accordion-wrapper">
            <details open="true" className="safety-details">
              <summary className="safety-summary">
                <div className="safety-summary-inner">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="safety-icon"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                  <span className="section-subtitle">
                    OSHA 30-Hour Certified Crew
                  </span>
                </div>
              </summary>
              <div className="safety-panel">
                <p className="section-content">
                  Every field operative at Panda Demolition is required to
                  complete the OSHA 30-hour Construction Safety and Health
                  training. We conduct weekly &quot;Toolbox Talks&quot; to
                  ensure current site hazards are identified and mitigated
                  before work begins.
                </p>
              </div>
            </details>
            <details className="safety-details">
              <summary className="safety-summary">
                <div className="safety-summary-inner">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="safety-icon"
                  >
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                    <path d="M17.4 22H6.6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6.9L20 6.5V20a2 2 0 0 1-2 2Z"></path>
                    <path d="m9 14 2 2 4-4"></path>
                  </svg>
                  <span className="section-subtitle">
                    Environmental Compliance &amp; Permits
                  </span>
                </div>
              </summary>
              <div className="safety-panel">
                <p className="section-content">
                  We manage all EPA-mandated documentation, including NESHAP
                  notifications and hazardous material manifests. Our disposal
                  practices are fully compliant with local landfill regulations
                  and green building standards (LEED).
                </p>
              </div>
            </details>
            <details className="safety-details">
              <summary className="safety-summary">
                <div className="safety-summary-inner">
                  <svg
                    fill="none"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="safety-icon"
                  >
                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                  </svg>
                  <span className="section-subtitle">
                    Equipment Maintenance Program
                  </span>
                </div>
              </summary>
              <div className="safety-panel">
                <p className="section-content">
                  Our fleet undergoes rigorous daily inspections and bi-weekly
                  deep-mechanical audits. We utilize telematics to monitor
                  machine health in real-time, preventing mechanical failures
                  that could lead to site accidents.
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section className="fleet-section">
        <div className="fleet-header">
          <h2 className="section-title">The Panda Fleet</h2>
          <p className="section-content">
            Heavy-duty machinery for every scale of destruction and removal.
          </p>
        </div>
        <div className="fleet-masonry">
          <div className="fleet-item">
            <img
              alt="Heavy Excavator"
              src="https://images.pexels.com/photos/188679/pexels-photo-188679.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="fleet-img"
            />
            <div className="fleet-caption">
              <h3 className="section-subtitle">High-Reach Excavators</h3>
              <p className="section-content">
                Precision demolition for structures up to 4 stories.
              </p>
            </div>
          </div>
          <div className="fleet-item">
            <img
              alt="Roll-off Truck"
              src="https://images.pexels.com/photos/32252461/pexels-photo-32252461.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="fleet-img"
            />
            <div className="fleet-caption">
              <h3 className="section-subtitle">Roll-Off Fleet</h3>
              <p className="section-content">
                10 to 40-yard dumpster delivery and hauling.
              </p>
            </div>
          </div>
          <div className="fleet-item">
            <img
              alt="Drilling Rig"
              src="https://images.pexels.com/photos/15109993/pexels-photo-15109993.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="fleet-img"
            />
            <div className="fleet-caption">
              <h3 className="section-subtitle">Specialized Tooling</h3>
              <p className="section-content">
                Hydraulic shears and concrete pulverizers.
              </p>
            </div>
          </div>
          <div className="fleet-item">
            <img
              alt="Forklift on site"
              src="https://images.pexels.com/photos/4487387/pexels-photo-4487387.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="fleet-img"
            />
            <div className="fleet-caption">
              <h3 className="section-subtitle">Site Support</h3>
              <p className="section-content">
                Compact loaders and site management vehicles.
              </p>
            </div>
          </div>
          <div className="fleet-item">
            <img
              alt="Industrial site"
              src="https://images.pexels.com/photos/12175620/pexels-photo-12175620.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="fleet-img"
            />
            <div className="fleet-caption">
              <h3 className="section-subtitle">Mobile Crushers</h3>
              <p className="section-content">
                On-site concrete recycling and processing.
              </p>
            </div>
          </div>
          <div className="fleet-item">
            <img
              alt="Excavator at road site"
              src="https://images.pexels.com/photos/17843294/pexels-photo-17843294.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="fleet-img"
            />
            <div className="fleet-caption">
              <h3 className="section-subtitle">Infrastructure Ready</h3>
              <p className="section-content">
                Equipped for public works and municipal projects.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="about-us-stats-section">
        <div className="about-us-stats-grid">
          <div className="stats-card">
            <span className="stats-number">5,200+</span>
            <h3 className="section-subtitle">Projects Completed</h3>
            <p className="section-content">
              From residential driveways to full-scale factory teardowns.
            </p>
          </div>
          <div className="stats-card">
            <span className="stats-number">98.5%</span>
            <h3 className="section-subtitle">On-Time Delivery</h3>
            <p className="section-content">
              Reliable dumpster drop-offs and project timeline adherence.
            </p>
          </div>
          <div className="stats-card">
            <span className="stats-number">1.2M</span>
            <h3 className="section-subtitle">Tons Hauled</h3>
            <p className="section-content">
              Safe and efficient debris removal across the tri-state area.
            </p>
          </div>
          <div className="stats-card">
            <span className="stats-number">0.00</span>
            <h3 className="section-subtitle">Safety Incident Rate</h3>
            <p className="section-content">
              Maintaining a perfect record for the last 36 consecutive months.
            </p>
          </div>
        </div>
      </section>
      <section className="team-section">
        <div className="team-container">
          <div className="team-header">
            <h2 className="section-title">The Experts Behind the Iron</h2>
            <p className="section-content">
              A team built on experience, certification, and grit.
            </p>
          </div>
          <div className="team-grid">
            <div className="team-card">
              <div className="team-image-wrapper">
                <img
                  alt="Marcus Chen"
                  src="https://images.pexels.com/photos/28196526/pexels-photo-28196526.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="team-img"
                />
              </div>
              <div className="team-info">
                <h3 className="section-subtitle">Marcus Chen</h3>
                <span className="team-role">Founder &amp; CEO</span>
                <p className="section-content">
                  25 years in heavy civil demolition and hazardous waste
                  management.
                </p>
              </div>
            </div>
            <div className="team-card">
              <div className="team-image-wrapper">
                <img
                  alt="Sarah Miller"
                  src="https://images.pexels.com/photos/16442672/pexels-photo-16442672.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="team-img"
                />
              </div>
              <div className="team-info">
                <h3 className="section-subtitle">Sarah Miller</h3>
                <span className="team-role">Chief Safety Officer</span>
                <p className="section-content">
                  Certified Safety Professional (CSP) with a focus on structural
                  stability.
                </p>
              </div>
            </div>
            <div className="team-card">
              <div className="team-image-wrapper">
                <img
                  alt="David Vane"
                  src="https://images.pexels.com/photos/31387781/pexels-photo-31387781.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="team-img"
                />
              </div>
              <div className="team-info">
                <h3 className="section-subtitle">David Vane</h3>
                <span className="team-role">Operations Director</span>
                <p className="section-content">
                  Logistics expert managing our 100+ vehicle fleet and disposal
                  routes.
                </p>
              </div>
            </div>
            <div className="team-card">
              <div className="team-image-wrapper">
                <img
                  alt="Elena Rodriguez"
                  src="https://images.pexels.com/photos/34194568/pexels-photo-34194568.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="team-img"
                />
              </div>
              <div className="team-info">
                <h3 className="section-subtitle">Elena Rodriguez</h3>
                <span className="team-role">Lead Site Engineer</span>
                <p className="section-content">
                  Specializes in explosive and mechanical structural demolition.
                </p>
              </div>
            </div>
            <div className="team-card">
              <div className="team-image-wrapper">
                <img
                  alt="Robert Taggert"
                  src="https://images.pexels.com/photos/15886880/pexels-photo-15886880.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="team-img"
                />
              </div>
              <div className="team-info">
                <h3 className="section-subtitle">Robert Taggert</h3>
                <span className="team-role">Fleet Superintendent</span>
                <p className="section-content">
                  Ensures every machine in our arsenal is peak-performance
                  ready.
                </p>
              </div>
            </div>
            <div className="team-card">
              <div className="team-image-wrapper">
                <img
                  alt="Jameson Blake"
                  src="https://images.pexels.com/photos/16368435/pexels-photo-16368435.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="team-img"
                />
              </div>
              <div className="team-info">
                <h3 className="section-subtitle">Jameson Blake</h3>
                <span className="team-role">HazMat Coordinator</span>
                <p className="section-content">
                  Expert in asbestos abatement and lead-safe disposal protocols.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-section">
        <div className="cta-split">
          <div className="cta-column cta-left">
            <div className="cta-content-box">
              <h2 className="section-title">Instant Dumpster Rental</h2>
              <p className="section-content">
                Need to clear debris fast? Order your roll-off dumpster online
                in seconds. Transparent pricing, no hidden fees.
              </p>
              <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="navigation-btn-reset">
                <div className="btn btn-xl btn-secondary">
                  <span>Book Online</span>
                </div>
              </button>
            </div>
          </div>
          <div className="cta-right cta-column">
            <div className="cta-content-box">
              <h2 className="section-title">Request Project RFQ</h2>
              <p className="section-content">
                Planning a major demolition or site clearing? Submit your specs
                for a comprehensive, safety-focused quote.
              </p>
              <a href="/rfq-portal">
                <div className="btn-primary btn btn-xl">
                  <span>Submit RFQ</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="about-us-container2">
        <div className="about-us-container3">
          <Script
            html={`<script defer data-name="panda-about">
(function(){
// Animation for timeline items on scroll
const timelineItems = document.querySelectorAll('.timeline-item');

const observerOptions = {
  threshold: 0.2,
  rootMargin: '0px 0px -50px 0px'
};

const timelineObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
      timelineObserver.unobserve(entry.target);
    }
  });
}, observerOptions);

timelineItems.forEach(item => {
  item.style.opacity = '0';
  item.style.transform = 'translateY(20px)';
  item.style.transition = 'all 0.5s ease-out';
  timelineObserver.observe(item);
});

// Stats counter animation
const statsNumbers = document.querySelectorAll('.stats-number');

const statsObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const target = entry.target;
      const countTo = parseFloat(target.innerText.replace(/[^0-9.]/g, ''));
      const suffix = target.innerText.replace(/[0-9.]/g, '');
      let current = 0;
      const duration = 2000;
      const stepTime = 20;
      const steps = duration / stepTime;
      const increment = countTo / steps;

      const timer = setInterval(() => {
        current += increment;
        if (current >= countTo) {
          target.innerText = countTo.toLocaleString() + suffix;
          clearInterval(timer);
        } else {
          // Handle decimals for safety rate
          if (countTo % 1 !== 0) {
            target.innerText = current.toFixed(2) + suffix;
          } else {
            target.innerText = Math.floor(current).toLocaleString() + suffix;
          }
        }
      }, stepTime);
      statsObserver.unobserve(target);
    }
  });
}, { threshold: 0.5 });

statsNumbers.forEach(stat => statsObserver.observe(stat));

// Accordion exclusive toggle (only one open at a time)
const detailsElements = document.querySelectorAll('.safety-details');
detailsElements.forEach((targetDetail) => {
  targetDetail.addEventListener('click', () => {
    detailsElements.forEach((detail) => {
      if (detail !== targetDetail) {
        detail.removeAttribute('open');
      }
    });
  });
});
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default AboutUs
